import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';

export type ShipmentSubmitAction = 'link' | 'connote';

export interface ShipmentFormActionsProps {
  saving: boolean;
  canDispatch: boolean;
  pendingAction?: ShipmentSubmitAction | null;
  /** Disable submit buttons even when not saving (e.g., manifest is empty). */
  submitDisabled?: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  onSubmitWithConnote: () => void;
}

const submitButtonSx = {
  fontSize: '11px',
  textTransform: 'none',
  fontWeight: 600,
  bgcolor: 'v4.accent',
  '&:hover': { bgcolor: 'v4.accent', opacity: 0.9 },
} as const;

export const ShipmentFormActions: React.FC<ShipmentFormActionsProps> = ({
  saving,
  canDispatch,
  pendingAction,
  submitDisabled = false,
  onCancel,
  onSubmit,
  onSubmitWithConnote,
}) => {
  const submitBlocked = saving || submitDisabled;
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1.5 }}>
      <Button
        size="small"
        variant="text"
        onClick={onCancel}
        disabled={saving}
        sx={{ fontSize: '11px', textTransform: 'none', color: 'text.secondary' }}
      >
        Cancel
      </Button>
      {canDispatch && (
        <>
          <Button
            size="small"
            variant="contained"
            onClick={onSubmit}
            disabled={submitBlocked}
            sx={submitButtonSx}
          >
            {saving && pendingAction === 'link' ? 'Creating...' : 'Create & Link'}
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={onSubmitWithConnote}
            disabled={submitBlocked}
            sx={submitButtonSx}
          >
            {saving && pendingAction === 'connote' ? 'Creating...' : 'Create & Add Connote'}
          </Button>
        </>
      )}
    </Box>
  );
};
